module.exports = __webpack_public_path__ + "static/media/wordpress.f69da95c.svg";